import pmPpcService from '@/services/pmPpcService';

export default {
  namespaced: true,

  state: {
    projectId: null,
    data: null,
    loading: false,
    error: null,
  },

  getters: {
    projectId: (state) => state.projectId,
    loading: (state) => state.loading,
    error: (state) => state.error,
    ppcData: (state) => state.data,
    currentWeek: (state) => state.data?.currentWeek ?? null,
    history: (state) => state.data?.history ?? [],
    hasData: (state) => Boolean(state.data?.currentWeek),
    isEmpty: (state) => {
      const week = state.data?.currentWeek;
      return !state.loading && !state.error && (!week || week.n === 0);
    },
    ppcPercent: (state) => state.data?.currentWeek?.ppc ?? null,
    commitmentCount: (state) => state.data?.currentWeek?.n ?? 0,
    trendDelta: (state) => state.data?.currentWeek?.deltaVsPreviousWeek ?? null,
    trendDirection: (state) => state.data?.currentWeek?.trendDirection ?? null,
    severity: (state) => state.data?.currentWeek?.severity ?? null,
    chartBars: (state) => (state.data?.history ?? []).map((entry) => ({
      label: entry.label,
      ppc: entry.ppc,
      n: entry.n,
      yearWeek: entry.yearWeek,
    })),
  },

  mutations: {
    SET_PROJECT_ID(state, projectId) {
      state.projectId = projectId;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    },
    SET_DATA(state, data) {
      state.data = data;
    },
    RESET(state) {
      state.projectId = null;
      state.data = null;
      state.loading = false;
      state.error = null;
    },
  },

  actions: {
    async fetchPpc({ commit, state }, projectId = state.projectId) {
      if (!projectId) {
        commit('RESET');
        return null;
      }

      commit('SET_PROJECT_ID', projectId);
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);

      try {
        const data = await pmPpcService.getProjectPpc(projectId, { weeks: 8 });
        commit('SET_DATA', data);
        return data;
      } catch (error) {
        commit('SET_ERROR', error?.message || 'Failed to load PPC');
        throw error;
      } finally {
        commit('SET_LOADING', false);
      }
    },
  },
};
